import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addCartItem, cartItemDecreament } from '../Redux/Cart-system'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'
import { addToCart } from '../Services/Operations/ProductAPI'
import {  baseURL } from '../Services/api_endpoints'
import Cookies from "js-cookie";


// const baseURL=baseURL|| "http://192.168.29.250:9998/api"

const CategoryProductCard = ({name,description,img,price,id,stock}) => {

  const[mobile,setMobile]=useState(window.innerWidth<600)
    const dispatch=useDispatch()
    const navigate=useNavigate()

    const carts=useSelector((state)=>state.cart.cartItems)

    const handleAddToCart = async()=>{

       if(!Cookies.get('loginData')){
              navigate('/login')
              toast.error("Unauthorized,Login first")
              return
            }
        try {
            const exists=carts.find(item => item.id === id);
            if(exists){
               toast.error("Item already exists in the cart")
               return;
            }
            if(stock<1){
              toast.info("Product stock is empty")
               return;
            }
            dispatch(addCartItem({name,id,price,quantity:1,img,stock}))

             const response=await addToCart({"productId":id, "quantity": 1,"price":price})
             if(response.status!==200){
              dispatch(cartItemDecreament({id:id}))
             return toast.error("Failed to addd cart in server")

             }else{
              toast.success("Item added to cart successfully")
             }
            
        } catch (error) {
           console.log("failed to add cart",error);
           
        }finally{
             console.log("carts : ",carts);
        }
        

       
        
        
    }

 function findCart(id){
          const exists=carts.find(item => item.id === id);
           return exists
      }

    useEffect(() => {
     findCart(id)
      
    }, [carts])
    



  return (
   
        <div className={`col-md-6 col-lg-4 col-xl-3  ${window.innerWidth<567?"h-[35vh] m-2":"h-[55vh]"}`} 
        style={{borderRadius:"10px", width:mobile?"35vw":"18vw",
          transition: "transform 0.3s ease-in-out"
        }}
           onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.05)")}
           onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
        >
                        <div className={`rounded position-relative fruite-item ${window.innerWidth<567?"h-[100%]":"h-[100%"}`} style={{borderRadius:"10px",height:"100%"}}>
                          <div   style={{width:"100%",overflow:"hidden",height:"60%"}}
                          onClick={() => navigate(`/shop-details/${id}`)}>
                            <img
                              src={`${baseURL+img}`}
                              className="img-fluid w-100 rounded-top product-img h-[38vh]"
                              alt
                             style={{objectFit:"fill",width:"100%",height:"100%"}}
                            />
                          </div>
                          <div
                            className="text-white bg-secondary px-3 py-1 rounded position-absolute"
                            style={{ top: 10, left: 10 }}
                            onClick={() => navigate(`/shop-details/${id}`)}
                          >
                            Ear
                          </div>
                         
                           
                          
                            <div className="d-flex  justify-content-between  align-items-center p-2 border border-secondary border-top-0 rounded-bottom" 
                            style={{flexDirection:"column",height:"40%"}}>
                             <p className='text-dark  fw-semibold'  
                              style={{fontSize:mobile?"15px":"20px"}} 
                             onClick={() => navigate(`/shop-details/${id}`)}>
                              {name.length > 18 ? name.slice(0, 18) + "..." : name}</p>
                            
                              <p className="text-dark  fw-bold mb-0" 
                              style={{fontSize:mobile?"10px":"13px"}}
                              >
                               ₹{price}
                              </p>
                              {!findCart(id)?
                              <div
                                onClick={handleAddToCart}
                                href="#"
                                className="btn border border-secondary rounded-pill px-3 text-primary"
                                style={{fontSize:mobile?"8px":"15px"}}
                              >
                              {" "}
                              {stock<=0?"Unavailable":  "Add to Cart"}
                               
                              </div>:
                              <div
                                onClick={()=>navigate('/cart')}
                                href="#"
                                className="btn border border-secondary rounded-pill px-3 text-primary"
                              >
                                <i className="fa fa-shopping-bag me-2 text-primary" />{" "}
                               Go To Cart
                              </div>}
                            </div>
                         
                        </div>
                      </div> 
   
  )
}

export default CategoryProductCard